


















































import { Component, Prop } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import ActivityType, { ActivityTypeIcons } from '@/models/Activities/ActivityType';
import ActivityDirection from '@/models/Activities/ActivityDirection';
import ActivityEntityType from '@/models/Activities/ActivityEntityType';

@Component({
    name: 'ActivityCreate'
})
export default class ActivityCreate extends GiganautVue {
    @Prop({ required: true })
    entityType!: ActivityEntityType;

    @Prop({ required: true })
    entityId!: string;

    @Prop({ default: false })
    excludeTask!: boolean;

    @Prop({ default: false })
    disabled!: boolean;

    ActivityType = ActivityType;
    ActivityTypeIcons = ActivityTypeIcons;
    ActivityDirection = ActivityDirection;

    selectType(activityType: ActivityType) {
        this.$emit('select', activityType);
    }

    selectCall(direction: ActivityDirection) {
        this.$emit('selectCall', direction);
    }

    selectEmail() {
        this.$emit('email');
    }
}
